import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import RichTextReactRenderer from 'components/RichTextReactRenderer';
import _get from 'lodash/get';

const useStyles = makeStyles(() => ({
  root: {
    paddingRight: 20,
  },
  title: {
    fontsize: 22,
    lineHeight: '29px',
    fontFamily: 'PoppinsSemiBold',
    marginBottom: 13,
    color: '#4B4B4B',
  },
  subtitle: {
    fontSize: 17,
    lineHeight: '23px',
    marginBottom: 14,
  },
  description: {
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '8',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // maxHeight: 105 /* Fallback for non-webkit */,
    '& img': {
      display: 'none',
    },
    '& p': {
      margin: 0,
      fontSize: 14,
      lineHeight: '22px',
    },
  },
  link: {
    fontSize: 14,
    lineHeight: '22px',
    fontFamily: 'MadaBold',
    color: '#01619B',
    marginTop: 14,
  },
  rightIcon: {
    marginLeft: 5,
    marginBottom: 3,
  },
}));

const ListInfo = ({ data, finalTitle, finalShortDescription }) => {
  const classes = useStyles();
  const title = _get(data, 'fields.title');
  const subtitle = _get(data, 'fields.subtitle');
  const shortDescription = _get(data, 'fields.shortDescription');
  const description = _get(data, 'fields.description');
  return (
    <Grid container className={classes.root} key={_get(data, 'fields.slug')}>
      <Grid item xs={12}>
        <Typography className={classes.title}>
          {subtitle ||
            finalShortDescription ||
            shortDescription ||
            finalTitle ||
            title}
        </Typography>
      </Grid>
      {description && (
        <div className={classes.description}>
          <RichTextReactRenderer data={description} />
        </div>
      )}
    </Grid>
  );
};

export default ListInfo;
